var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrashFull = function SvgTrashFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.667C1 11.4 1.6 12 2.333 12h5.334C8.4 12 9 11.4 9 10.667v-8H1v8Zm8.667-10H7.333L6.667 0H3.333l-.666.667H.333V2h9.334V.667Z",
    fill: "currentColor"
  })));
};
export { SvgTrashFull as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMCAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgMTAuNjY2N0MxIDExLjQgMS42IDEyIDIuMzMzMzQgMTJINy42NjY2N0M4LjQgMTIgOSAxMS40IDkgMTAuNjY2N1YyLjY2NjY3SDFWMTAuNjY2N1pNOS42NjY2NyAwLjY2NjY2N0g3LjMzMzM0TDYuNjY2NjcgMEgzLjMzMzM0TDIuNjY2NjcgMC42NjY2NjdIMC4zMzMzMzZWMkg5LjY2NjY3VjAuNjY2NjY3WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";